import { useStore } from 'react-redux';
import { useState } from 'react';
import type { Reducer } from '@reduxjs/toolkit';

export const useInjectReducer = ({ key, reducer }: { key: string; reducer: Reducer }) => {
  const store = useStore() as any;
  
  useState(() => {
    if (store.asyncReducer) {
      store.asyncReducer.inject({ reducerPath: key, reducer });
      // Force a replace reducer to ensure state initialization events are fired
      store.replaceReducer(store.asyncReducer);
    }
    return true;
  });
};
